import { Component, OnInit, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { G_PurchaseMasterViewModel } from 'src/app/viewmodels/g-purchase/G_PurchaseMasterViewModel';
import { ActivatedRoute, Router } from '@angular/router';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { HttpClient } from '@angular/common/http';
import { AccountDefiningModel, DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import Swal from 'sweetalert2';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { G_Installment_View_Model } from 'src/app/viewmodels/g-purchase/G_Installment_View_Model';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { G_Bulk_Installment_View_Model } from 'src/app/viewmodels/g-purchase/G_Bulk_Installment_View_Model';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { SaveBulkInstallmentRequest } from 'src/app/viewmodels/g-sale/GSaleViewModel';
import { SaveGInstallmentRequest, SaveSaleMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { AppConsts } from 'src/app/common/app-consts';

@Component({
  selector: 'app-bulk-payments',
  templateUrl: './bulk-payments.component.html',
  styleUrls: ['./bulk-payments.component.scss']
})
export class BulkPaymentsComponent implements OnInit {
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  @Input() public modal_title: any;
  public SortBy: string = "asc";
  public modalRef: BsModalRef;
  public vmS: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public vmListItems: any = [];
  public vmListItem: any = [];
  public vmD: AccountDefiningModel = new AccountDefiningModel();
  public vmI: SaveGInstallmentRequest = new SaveGInstallmentRequest();
  @Input() public bulkInstallment: SaveBulkInstallmentRequest;
  public IsDisable: boolean = false;
  dataTable: any;
  public customerDetail: any = [];
  @Input('dataTable') table;
  dtOption: any = {};
  public component_Title = 'Bulk Payments';
  public isEdit = false;
  public isDisabled = false;
  public refid: number;
  public total: number;
  public paidamount: number;
  public balance: number;
  public calingUrl: string;
  public urlId: string;
  public isPreview: boolean = false;
  private submitted = false;
  public suppliers: any = [];
  public selectedCustomer: any = [];
  public accountSelected: any = [];
  public accountList: ItemViewModel1[] = [];
  public fd: Date;
  public td: Date;

  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';

  public accountDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true,
    limitSelection: 1
  };

  public CustomerDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'accTitle',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true,
    limitSelection: 1
  };
  public nowDate: Date;
  public client: any;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.client = this._localStorageService.get("com");
    this.nowDate = new Date();
    this.getAccount('CaB');
    this.getCustomers();
    debugger
    if (this.vmI == undefined) {
      this.vmI = new SaveGInstallmentRequest();
      this.vmI.transactionDate = new Date();
      this.vmI.gSale = new ItemViewModel1(0, '');
    }
    if (this.bulkInstallment == undefined) {
      this.bulkInstallment = new SaveBulkInstallmentRequest();
      this.bulkInstallment.transactionDate = new Date();
      this.bulkInstallment.cashAndBank = new ItemViewModel1;
      this.bulkInstallment.cashAndBank.id = 0;
      this.bulkInstallment.cashAndBank.name = "";
      this.bulkInstallment.customer = new ItemViewModel1;
      this.bulkInstallment.customer.id = 0;
      this.bulkInstallment.customer.name = "";
      this.bulkInstallment.totalBalance = 0;
      this.bulkInstallment.remarks = "";
      this.bulkInstallment.totalInvoiceAmount = 0;
      this.bulkInstallment.bulkInstallments = [];
      this.bulkInstallment.totalPaidAmount = 0;
      this.bulkInstallment.totalAmount = 0;
      this.getRefId();
    } else {
      this.bulkInstallment.transactionDate = new Date();
      this.isDisabled = true;
      this.calingUrl = this._router.url;
      this.route.queryParams.subscribe(params => {
        this.urlId = params['id'];
        this.spinner.show();
        debugger
        this._uow.gSaleService.GetGBulkPaymentByIdAsync(this.urlId).subscribe((res: any) => {
          debugger
          this.bulkInstallment = res;
          this.bulkInstallment.bulkInstallments = res.bulkInstallments;
          this.bulkInstallment.transactionDate = new Date(res.transactionDate);
          this.InvoicesTotal();


          this.bulkInstallment.transactionDate = new Date(this.bulkInstallment.transactionDate);
          let selectedCustomers: any = [];
          if (this.bulkInstallment.customer != undefined && this.bulkInstallment.customer != null) {
            let sCA = new AccountDefiningModel();
            sCA.id = this.bulkInstallment.customer.id;
            sCA.accTitle = this.bulkInstallment.customer.name;
            selectedCustomers.push(sCA);
            this.selectedCustomer = selectedCustomers;
            this.bulkInstallment.customer = new ItemViewModel1(this.bulkInstallment.customer.id, this.bulkInstallment.customer.name);
          }
          let account: any = [];
          if (this.bulkInstallment.cashAndBank != undefined && this.bulkInstallment.cashAndBank != null) {
            let sCA = new ItemViewModel1();
            sCA.id = this.bulkInstallment.cashAndBank.id;
            sCA.name = this.bulkInstallment.cashAndBank.name;
            account.push(sCA);
            this.accountSelected = account;
            this.bulkInstallment.cashAndBank = new ItemViewModel1(this.bulkInstallment.cashAndBank.id, this.bulkInstallment.cashAndBank.name);
          }
          this.bulkInstallment.cashAndBank.name = this.bulkInstallment.cashAndBank.name;
          this.bulkInstallment.totalInvoiceAmount = this.bulkInstallment.totalInvoiceAmount;
          this.bulkInstallment.totalPaidAmount = this.bulkInstallment.totalPaidAmount;
          this.bulkInstallment.totalBalance = this.bulkInstallment.totalBalance;
          this.bulkInstallment.totalAmount = this.bulkInstallment.totalAmount;
          this.bulkInstallment.remarks = this.bulkInstallment.remarks;
        })
      });
      debugger
      

    }
    if (this.vmS == undefined) {
      this.vmS = new SaveSaleMasterRequest();
      this.vmS.transactionDate = new Date();
      this.vmS.paymentType = 1;
      this.vmS.saleDetails = [];
      this.vmS.customerAcc = new ItemViewModel1();
      this.vmS.customerAcc.id = 0;
      this.vmS.customerAcc.name = "";
      this.vmS.paidAmount = 0;
      this.vmS.invAmount = 0;
    }

    this.spinner.hide();
  }

  getRefId() {
    this._uow.gSaleService.GetGBulkPaymentsRefIdAsync().subscribe((res: any) => {
      if (res) {
        this.bulkInstallment.refId = res.code;
        console.log(res);
      }
    }, err => {
      console.log(err);
    });
  }

  getAccount(x: string) {
    debugger
    this._uow.gSettingService.GetAccountsBySearchAsync(x).subscribe((res: any) => {
      if (res) {
        this.accountList = res.result;
        console.log(res);
      }
    }, err => {
      console.log(err);
    });
  }

  getCustomers() {
    debugger;
    this._jq.showSpinner(true);
    let Customer = AppConsts.CUSTOMER;
    this._uow.gSettingService.GetGCustomersDropDownAsync(Customer).subscribe(
      (res: any) => {
        debugger;
        this.customerDetail = res.result;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this.customerDetail = [];
        this._jq.showSpinner();
      }
    );
  }
  public customerData: ItemViewModel1;
  onSelectCustomer(e) {
    debugger
    let item = this.customerDetail.find(x => x.id === e.id);
    //  let i = new G_Installment_View_Model();
    //  i.G_Fk_DabitAccount_Id = new ItemViewModel();
    //  i.G_Fk_DabitAccount_Id.Id = item.Id;
    //  i.G_Fk_DabitAccount_Id.Name = item.Name;
    this.customerData = new ItemViewModel1();
    this.customerData.id = item.id;
    this.customerData.name = item.accTitle;
  }

  public acountData: ItemViewModel1;
  onSelectSupplier(e) {
    let item = this.accountList.find(x => x.id === e.id);
    //  let i = new G_Installment_View_Model();
    //  i.G_Fk_DabitAccount_Id = new ItemViewModel();
    //  i.G_Fk_DabitAccount_Id.Id = item.Id;
    //  i.G_Fk_DabitAccount_Id.Name = item.Name;
    this.acountData = new ItemViewModel1();
    this.acountData.id = item.id;
    this.acountData.name = item.name;

  }

  getCustomerInvoice() {
    debugger
    //this.bulkInstallment = new G_Bulk_Installment_View_Model();

    if (this.customerData == null || this.customerData.id == 0 || this.customerData.id == null || this.customerData.id == undefined) {
      Swal.fire(
        'Failure',
        'Customer account is required',
        'error'
      );
      return;
    }

    if (this.fd == null || this.fd == undefined || this.td == null || this.td == undefined) {
      Swal.fire(
        'Failure',
        'From & To Date is required',
        'error'
      );
      return;
    }
    if (this.customerData != null) {
      this._uow.gSaleService.GetInvoiceByCustomerIdAsync(this.customerData.id, this.fd.toISOString(), this.td.toISOString()).subscribe((res: any) => {
        //this.vmListItems = res;
        debugger
        this.bulkInstallment.bulkInstallments = res.result;
        this.bulkInstallment.bulkInstallments.forEach(e => {
          let existingList = this.bulkInstallment.bulkInstallments.find(x => x.gSale.id === e.gSale.id);
          if (existingList == undefined) {
            this.bulkInstallment.bulkInstallments = res.result;
          }
          else {
            //this.bulkInstallment.BulkInstallments = res;
          }
        });

        this.InvoicesTotal();
        console.log(res);
      }, (err) => {
        console.log(err);
        this._jq.showSpinner();
      });
    }
    // if (this.bulkInstallment.customer != null) {
    //   let id = this.bulkInstallment.customer.id;
    //   this._uow.gSaleService.GetInvoiceByCustomerIdAsync(id, this.fd.toISOString(), this.td.toISOString()).subscribe((res: any) => {
    //     //this.vmListItems = res;
    //     this.bulkInstallment.bulkInstallments = res.result;
    //     debugger
    //     this.bulkInstallment.bulkInstallments.forEach(e => {
    //       let existingList = this.bulkInstallment.bulkInstallments.find(x => x.gSale.id === e.gSale.id);
    //       if (existingList == undefined) {
    //         this.bulkInstallment.bulkInstallments = res;
    //       }
    //       else {
    //         //this.bulkInstallment.BulkInstallments = res;
    //       }
    //     });
    //     this.InvoicesTotal();
    //     console.log(res);
    //   }, (err) => {
    //     console.log(err);
    //     this._jq.showSpinner();
    //   });
    // }
  }

  InvoicesTotal() {
    debugger
    this.bulkInstallment.totalInvoiceAmount = 0;
    this.bulkInstallment.totalPaidAmount = 0;
    this.bulkInstallment.totalBalance = 0;
    this.bulkInstallment.totalAmount = 0;
    if (this.bulkInstallment.bulkInstallments.length > 0) {
      this.bulkInstallment.bulkInstallments.forEach(element => {
        this.bulkInstallment.totalInvoiceAmount += element.invoiceAmount;
        this.bulkInstallment.totalPaidAmount += element.amount;
        this.bulkInstallment.totalBalance += (element.invoiceAmount - element.amount);
        this.bulkInstallment.totalAmount += element.amount;
        debugger
        //element.paidAmount = element.amount;
        if (element.amount > element.remainingAmount) {
          element.isDisable = true;
          this.IsDisable = true;
        } else {
          element.isDisable = false;
          this.IsDisable = false;
        }
        let disblObject = this.bulkInstallment.bulkInstallments.find(x => x.isDisable == true);
        if (disblObject != undefined) {
          this.IsDisable = true;
        } else {
          this.IsDisable = false;
        }
      });
    }
  }

  openModalLg(template: TemplateRef<any>) {
    debugger
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-xl');
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }

  amountChange() {
    debugger
    this.InvoicesTotal();
  }
  formatAmount(item: any) {
  if (item.amount != null && item.amount !== '') {
    item.amount = +Number(item.amount).toFixed(4);
  }
}

  saveOrUpdate() {
    debugger
    if (this.bulkInstallment.cashAndBank.id == 0 || this.bulkInstallment.cashAndBank.id == undefined || this.bulkInstallment.cashAndBank.id == null) {
      this.bulkInstallment.cashAndBank = new ItemViewModel1();
      this.bulkInstallment.cashAndBank.id = this.acountData.id;
      this.bulkInstallment.cashAndBank.name = this.acountData.name;
    } else {
      this.accountSelected.Id == this.bulkInstallment.cashAndBank.id;
      this.accountSelected.Name == this.bulkInstallment.cashAndBank.name
      //this.bulkInstallment.FK_G_CashAndBank_Id.Id == this.accountSelected.Id;
      //this.bulkInstallment.FK_G_CashAndBank_Id.Name == this.accountSelected.Name;
    }
    if (this.bulkInstallment.customer.id == 0 || this.bulkInstallment.customer.id == undefined || this.bulkInstallment.customer.id == null) {
      this.bulkInstallment.customer = new ItemViewModel1();
      this.bulkInstallment.customer.id = this.customerData.id;
      this.bulkInstallment.customer.name = this.customerData.name;
    } else {
      this.selectedCustomer.Id == this.bulkInstallment.customer.id;
      this.selectedCustomer.Name == this.bulkInstallment.customer.name;
    }
    // this._jq.showSpinner(true);
    this.spinner.show();
    //this._uow.saleService.PostBulkPayment(this.bulkInstallment).toPromise().then((res: any) => {
    this._uow.gSaleService.SaveBulkPaymentsAsync(this.bulkInstallment).toPromise().then((res: any) => {
      this.submitted = true;
      this.onSubmitted.emit(this.submitted);
      this.bsmRef.hide();
      console.log(res);
      // this._jq.showSpinner();
      this.spinner.hide();
      Swal.fire(
        'Created',
        'Payment Paid',
        'success'
      )
    })
      .catch((error) => {
        Swal.fire(
          'Failure',
          'Payment Not Paid',
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(false);
        this.spinner.hide();
        // this._jq.showSpinner();
      });


  }

  confirmDelete(e) {
    let delBInst = this.bulkInstallment.bulkInstallments.find(x => x.gSale.id == e.gSale.id);
    this.bulkInstallment.bulkInstallments.splice(this.bulkInstallment.bulkInstallments.indexOf(delBInst), 1);
    this.InvoicesTotal();
    // this._uow.saleService.DeleteBulk(this.bulkInstallment).subscribe((res: any) => {
    //   this.ngOnInit();
    //   this.modalRef.hide();
    //   this.InvoicesTotal();
    //   Swal.fire(
    //     'Saved!',
    //     'Repair Order Deletd!',
    //     'success'
    //   )
    // }, (err) => {
    //   Swal.fire(
    //     'Saved!',
    //     'Repair Order Not Deletd!',
    //     'error'
    //   )
    // });
    // if (this.calingUrl.startsWith('/purchase')) {
    //   this._uow.purchaseService.DeleteInstallment(this.vmI).subscribe((res: any) => {
    //     this.getLatestPurchaseData();
    //     Swal.fire(
    //       'Deleted!',
    //       'Installment Deleted!',
    //       'success'
    //     )
    //     this.modalRef.hide();
    //   }, (err) => {
    //     console.log(err);
    //     Swal.fire(
    //       'Failure!',
    //       'Installment Not Deleted!',
    //       'error'
    //     )
    //    });
    //   }

    // if (this.calingUrl.startsWith('/direct-sale-dtl-view')) {
    //   this._uow.purchaseService.DeleteInstallment(this.vmI).subscribe((res: any) => {
    //     this.getSaleList();
    //     this.getLatestSaleData();
    //     Swal.fire(
    //       'Deleted!',
    //       'Installment Deleted!',
    //       'success'
    //     )
    //     this.modalRef.hide();
    //   }, (err) => {
    //     console.log(err);
    //     Swal.fire(
    //       'Failure!',
    //       'Installment Not Deleted!',
    //       'error'
    //     )
    //    });
    // }

    // if (this.calingUrl.startsWith('/direct-sale-list')) {
    //   this._uow.purchaseService.DeleteInstallment(this.vmI).subscribe((res: any) => {
    //     this.getSaleList();
    //     this.getLatestSaleData();
    //     Swal.fire(
    //       'Deleted!',
    //       'Installment Deleted!',
    //       'success'
    //     )
    //     this.modalRef.hide();
    //   }, (err) => {
    //     console.log(err);
    //     Swal.fire(
    //       'Failure!',
    //       'Installment Not Deleted!',
    //       'error'
    //     )
    //    });
    // }
    // if (this.calingUrl.startsWith('/payment-status')) {
    //   this._uow.purchaseService.DeleteInstallment(this.vmI).subscribe((res: any) => {
    //     this.getSaleList();
    //     this.getLatestSaleData();
    //     Swal.fire(
    //       'Deleted!',
    //       'Installment Deleted!',
    //       'success'
    //     )
    //     this.modalRef.hide();
    //   }, (err) => {
    //     console.log(err);
    //     Swal.fire(
    //       'Failure!',
    //       'Installment Not Deleted!',
    //       'error'
    //     )
    //    });
    // }
  }

  // EditPurchaseInstallment(b) {
  //     this.bulkInstallment.TransactionDate = new Date(b.TransactionDate);
  //     this.bulkInstallment.FK_G_CashAndBank_Id = new ItemViewModel();
  //     this.bulkInstallment.FK_G_CashAndBank_Id.Id - this.acountData.Id;
  //     this.bulkInstallment.FK_G_CashAndBank_Id.Name = this.acountData.Name;
  //     this.bulkInstallment.TotalInvoiceAmount = b.TotalInvoiceAmount;
  //     this.bulkInstallment.TotalPaidAmount = b.TotalPaidAmount;
  //     this.bulkInstallment.TotalBalance = b.TotalBalance;
  //     this.bulkInstallment.TotalAmount = b.TotalAmount;
  //     this.bulkInstallment.Remarks = b.Remarks;
  //     this.bulkInstallment.BulkInstallments.forEach(element => {
  //       let bulkDetail = this.bulkInstallment.BulkInstallments.find(x => x.G_FK_Sale_Id === b.G_FK_Sale_Id.Id);
  //       bulkDetail.G_FK_Sale_Id = new ItemViewModel(b.G_FK_Sale_Id.Id, b.G_FK_Sale_Id.Name);
  //       bulkDetail.G_FK_Sale_Id.Id = element.G_FK_Sale_Id.Id;
  //       bulkDetail.G_FK_Sale_Id.Name = element.G_FK_Sale_Id.Name;
  //       bulkDetail.InvoiceAmount = element.InvoiceAmount;
  //       bulkDetail.PaidAmount = element.PaidAmount;
  //       bulkDetail.RemainingAmount = element.RemainingAmount;
  //       bulkDetail.Amount = element.Amount;
  //       bulkDetail.TransactionDate = new Date(element.TransactionDate);
  //     });

  //   }





















































  public attachfile(event) {
    this.vmI.file = event.target.files[0];
  }



  public deleteId: string
  openDeleteModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.bulkInstallment = model;
      this.deleteId = model.uniqueId;
    }
  }


  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template);

  }

  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.vmI = new SaveGInstallmentRequest();
    }
  }



}
